module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"label_active":{"0":"Inativo","1":"Ativo","true":"Ativo","false":"Inativo"}},"en":{"label_active":{"0":"Inactive","1":"Active","true":"Active","false":"Inactive"}}}')
  delete Component.options._Ctor
}
